import {styled, TableCell, tableCellClasses} from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#DCDCDC',
        color: 'black',
        borderRightWidth: 1,
        borderRightColor: '#ffffff',
        '&:last-child': {
            borderRightColor: theme.palette.grey[300],
        },
        '&:first-child': {
            borderLeftColor: theme.palette.grey[300],
        },
        borderRightStyle: "solid",
    },
    [`&.${tableCellClasses.body}`]: {
        borderRightWidth: 1,
        borderRightColor: theme.palette.grey[300],
        borderRightStyle: "solid",
    },
}));

export default StyledTableCell